import styled from 'styled-components';

interface Props {
  text: string;
  onClose: () => void;
}

function Alert({ text, onClose }: Props) {
  return (
    <Container
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClose();
      }}
    >
      <Inner onClick={(e) => e.stopPropagation()}>
        <Text>{text}</Text>
        <ConfirmButton
          onClick={() => {
            onClose();
          }}
        >
          확인
        </ConfirmButton>
      </Inner>
    </Container>
  );
}

export default Alert;

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Inner = styled.div`
  width: 328px;
  padding: 24px 20px;
  background-color: #fff;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Text = styled.div`
  align-self: stretch;
  color: #222;
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.36px;
  white-space: pre-line;
`;

const ConfirmButton = styled.button`
  border: none;
  outline: none;

  display: flex;
  padding: 14px 28px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  flex: 1 0 0;
  border-radius: 8px;
  background: #008aff;

  color: #fff;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;
`;
